// extracted by mini-css-extract-plugin
export default {"clientInfoColumn":"ClientInfoColumn_clientInfoColumn__w69Wc"};